var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemErrorHandlerReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a.75.75 0 01.75.75v4.5a.75.75 0 11-1.5 0v-4.5A.75.75 0 0112 7.5zm0 9.75A1.125 1.125 0 1012 15a1.125 1.125 0 000 2.25zM10.714 3.063c-.805.536-1.67.977-2.577 1.313a13.9 13.9 0 01-4.05.864c-.084.005-.17.008-.254.01h-.076A.75.75 0 003 6v4.133a11.25 11.25 0 005.527 9.685l3.094 1.829a.75.75 0 00.763 0l3.09-1.827A11.25 11.25 0 0021 10.134V6a.75.75 0 00-.762-.75h-.075a11.829 11.829 0 01-1.206-.096 13.472 13.472 0 01-3.077-.777 13.036 13.036 0 01-2.586-1.32 7.621 7.621 0 01-.6-.445 3.117 3.117 0 01-.166-.147.75.75 0 00-1.059.007l-.163.146c-.123.105-.32.26-.591.445zM4.5 10.133V6.716a15.397 15.397 0 004.17-.94 13.953 13.953 0 002.889-1.474c.173-.117.321-.225.447-.322.127.096.277.204.45.32.636.428 1.587.976 2.883 1.475a14.97 14.97 0 004.161.945v3.416a9.75 9.75 0 01-4.79 8.394l-2.709 1.6-2.71-1.602A9.75 9.75 0 014.5 10.133z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconMenuItemErrorHandlerReport;